module.exports = "/static/media/mobile.a7adbf9d.svg";